<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div class="pageTitle">
      {{ "placaQueryFiles.titleList" | translate }}
    </div>

    <div class="filterTableContainer">
      <app-filters
        #insideTable
        [filterList]="filterList"
        [ngClass]="{ filterHidden: !showTableFilter }"
      ></app-filters>

      <app-table
        [tableList]="tableList"
        [elementList]="placaFilesList"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons] = "showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
        (downloadFile)="descargaDoc($event)"
      ></app-table>

      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </div>
</div>
